<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        My Profile
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Profile</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Manage Profile</h3>
        </div>

        <form class="form-horizontal">
          <div class="box-body" style="overflow: unset;">
            <div class="form-group">
              <label for="name"
                class="col-sm-2 control-label">
                Full Name<span class="req">*</span>
              </label>

              <div class="col-sm-10">
                <input type="text"
                  class="form-control"
                  id="name"
                  v-model="form.name"
                  placeholder="FullName">
              </div>
            </div>

            <div class="form-group">
              <label for="email"
                class="col-sm-2 control-label">
                Email
              </label>

              <div class="col-sm-10 margin-top">
                {{form.email}}
              </div>
            </div>

            <div class="form-group">
              <label for="role"
                class="col-sm-2 control-label">
                Role
              </label>

              <div class="col-sm-10 margin-top">
                {{form.role}}
              </div>
            </div>
          </div>

          <div class="box-footer">
            <button @click.prevent='updateProfile' class="btn btn-info pull-right">Update</button>
          </div>
        </form>
      </div>

      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Change Password</h3>
        </div>

        <form class="form-horizontal">
          <div class="box-body"  style="overflow: unset;">
            <div class="form-group">
              <label for="old_password"
                class="col-sm-2 control-label">
                Old Password<span class="req">*</span>
              </label>

              <div class="col-sm-10">
                <input type="password"
                  class="form-control"
                  id="old_password"
                  v-model="form.old_password"
                  placeholder="Old Password">
              </div>
            </div>

            <div class="form-group">
              <label for="new_password"
                class="col-sm-2 control-label">
                New Password<span class="req">*</span>
              </label>

              <div class="col-sm-10">
                <input type="password"
                  class="form-control"
                  id="new_password"
                  v-model="form.new_password"
                  placeholder="New Password">
                <span>
                  Password must contains at least 1 uppercase, 1 lowercase and 8 character long
                </span>
              </div>
            </div>

            <div class="form-group">
              <label for="confirm_password"
                class="col-sm-2 control-label">
                Confirm New Password<span class="req">*</span>
              </label>

              <div class="col-sm-10">
                <input type="password"
                  class="form-control"
                  id="confirm_password"
                  v-model="form.confirm_password"
                  placeholder="New Password">
              </div>
            </div>
          </div>

          <div class="box-footer">
            <button @click.prevent='updatePassword' class="btn btn-info pull-right">Update</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import Common from '@/mixins/Common';

export default {
  name: 'ProfileForm',
  mixins: [Common],
  data() {
    return {
      isLoading: false,
      error: null,
      form: {
        name: null,
        email: null,
        role: null,
        id: null,

        old_password: null,
        new_password: null,
        confirm_password: null,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.setProfileData(this.$store.state.user);
    },
    
    setProfileData(user) {
      this.form.name = user.name;
      this.form.email = user.email;
      this.form.role = user.role;
      this.form.id = user.id;
    },

    async updateProfile() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return;
      }

      const data = this.generateData();
      try {
        await this.axios.put(`/users/${this.form.id}`, data);
        this.$store.commit('SET_USER_NAME', this.form.name);
        this.successModal('profile');
      } catch (error) {
        this.failedModal('update data');
      }
    },

    generateData() {
      const formData = new FormData();

      formData.append('name', this.form.name);
      formData.append('email', this.form.email);
      formData.append('role', this.form.role);

      return formData;
    },

    async updatePassword() {
      const result = this.validatePassword();
      if (!result) return;

      const data = this.generatePasswordData();
      try {
        await this.axios.put(`/users/password/${this.form.id}`, data);
        this.successModal('password');
        this.setPasswordEmpty();
      } catch (error) {
        if (error.response) {
          let errMsg = error.response.data.errors;

          if (errMsg === 'Invalid Old Password') {
            errMsg = 'The old password you have entered is incorrect';
          }

          this.failedModal('update password', errMsg);
        } else {
          this.failedModal('update password');
        }
      }
    },

    validatePassword() {
      if (!this.form.old_password) {
        this.$swal('Old Password required', 'Please fill old password to continue', 'warning');
        return false;
      }

      if (!this.form.new_password) {
        this.$swal('New Password required', 'Please fill new password to continue', 'warning');
        return false;
      }

      if (!this.form.confirm_password) {
        this.$swal('New Password Confirm required', 'Please fill new password confirm to continue', 'warning');
        return false;
      }

      const pattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z]).{8,}$');
      if (!pattern.test(this.form.new_password)) {
        this.$swal('Invalid New Password', 'Password must contains at least 1 uppercase, 1 lowercase and 8 character long', 'warning');
        return false;
      }

      if (this.form.confirm_password !== this.form.new_password) {
        this.$swal('Invalid New Password', 'The password confirmation does not match', 'warning');
        return false;
      }

      return true;
    },

    generatePasswordData() {
      const formData = new FormData();

      formData.append('old_password', this.form.old_password);
      formData.append('new_password', this.form.new_password);
      formData.append('new_password_confirm', this.form.confirm_password);

      return formData;
    },

    successModal(type) {
      this.$swal({
        title: 'Updated',
        text: `${this.capitalizeFirstLetter(type)} has been Updated.`,
        type: 'success',
        timer: 3000,
      });
    },

    failedModal(type, text) {
      this.$swal({
        title: `${this.capitalizeFirstLetter(type)} Failed!`,
        text: !text ? `Failed to ${type}` : text,
        type: 'warning',
        timer: 4000,
      });
    },

    setPasswordEmpty() {
      this.form.old_password = null;
      this.form.new_password = null;
      this.form.confirm_password = null;
    },
  },
};
</script>

<style lang="scss" scoped>
  .margin-top {
    margin-top: 0.65rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/modules/profile/form.vue